import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import aImg1 from "../assets/pictures/old/a.png";
import iImg1 from "../assets/pictures/old/i.png";
import mImg1 from "../assets/pictures/old/m.png";
import sImg1 from "../assets/pictures/old/s.png";
import ssImg1 from "../assets/pictures/old/ss.png";
import uImg1 from "../assets/pictures/old/u.png";
import aImg2 from "../assets/pictures/new/a.png";
import iImg2 from "../assets/pictures/new/i.png";
import mImg2 from "../assets/pictures/new/m.png";
import sImg2 from "../assets/pictures/new/s.png";
import ssImg2 from "../assets/pictures/new/ss.png";
import uImg2 from "../assets/pictures/new/u.png";

export default function QuizImages(props) {
  return (
    <ImageList className="image-list" cols={3}>
      {imageList.map((item) => (
        <ImageListItem key={item.id}>
          <img
            id={item.id}
            src={props.mode === "new" ? item.source2 : item.source1}
            alt={item.title}
            className="image-list-button"
            hoverable=""
            onClick={() => {
              if (
                !props.answeredCorrectly &&
                !props.failedAnswer &&
                document.getElementById(item.id).hasAttribute("hoverable")
              ) {
                props.checkAnswer(item.id);
              }
            }}
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

const imageList = [
  {
    id: 1,
    source1: aImg1,
    source2: aImg2,
  },
  {
    id: 2,
    source1: iImg1,
    source2: iImg2,
  },
  {
    id: 3,
    source1: mImg1,
    source2: mImg2,
  },
  {
    id: 4,
    source1: sImg1,
    source2: sImg2,
  },
  {
    id: 5,
    source1: ssImg1,
    source2: ssImg2,
  },
  {
    id: 6,
    source1: uImg1,
    source2: uImg2,
  },
];
